import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useSurveyGroupFiltersQueryKey } from './useSurveyGroupFiltersQueryKey'

export const useInvalidateSurveyGroupFiltersQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useSurveyGroupFiltersQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
